<template>
  <v-row>
    <v-col cols="12">
      <loader v-if="loadingState" />

      <div v-else>
        <v-row v-if="data.length < 1">
          <no-data class="mx-auto" />
        </v-row>

        <videos :videos="data" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import * as api from "../config/api.js";
import Videos from "../components/home/youtubeVideos.vue";
export default {
  beforeMount() {
    this.getData();
  },
  components: {
    Videos,
  },
  computed: {},
  data() {
    return {
      loadingState: false,
      data: [],
    };
  },
  methods: {
    getData() {
      this.loadingState = true;
      this.$http
        .get(api.GALLERY_VIDEOS)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          alert("Error Occurred");
          console.log(" Error=======>", error.response.data);
          if (error.response.status == 403) {
            alert();
          }
        })
        .finally(() => {
          this.loadingState = false;
        });
    },
  },
  mounted() {},
  props: {},
  updated() {},
  watch: {},
};
</script>

<style scoped></style>
